export enum EPreapprovalLogic {
    SKIP_ILLION = 'NO_ILLION',
    SKIP_PREAPPROVAL = 'SKIP_PREAPPROVAL',
}
